import { generateNomenApi, generateNomenOptions } from '@feature/nomenclature';

const bdiApi = generateNomenApi(`/nomen/bdi`);

export const bdiOptions = generateNomenOptions('bdi', bdiApi);
